export const getIcon = (size = 24, color = '#1f1f1f') => {
  return `
    <svg xmlns="http://www.w3.org/2000/svg" height="${size}px" viewBox="0 0 24 24" width="${size}px" fill="none">
      <g clip-path="url(#clip0_1312_20008)">
        <path d="M2.25497 0.844971L0.844971 2.25497L2.84497 4.25497V20.155H18.745L21.745 23.155L23.155 21.745L2.25497 0.844971ZM6.84497 18.155H4.84497V16.155H6.84497V18.155ZM6.84497 14.155H4.84497V12.155H6.84497V14.155ZM4.84497 10.155V8.15497H6.84497V10.155H4.84497ZM10.845 18.155H8.84497V16.155H10.845V18.155ZM8.84497 14.155V12.155H10.845V14.155H8.84497ZM12.845 18.155V16.155H14.745L16.745 18.155H12.845ZM8.84497 4.15497H10.845V6.15497H10.395L12.845 8.60497V8.15497H20.845V16.605L22.845 18.605V6.15497H12.845V2.15497H6.39497L8.84497 4.60497V4.15497ZM16.845 10.155H18.845V12.155H16.845V10.155Z" fill="${color}"/>
      </g>
      <defs>
        <clipPath id="clip0_1312_20008">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `;
};
